export default "__VITE_ASSET__fb91011e__"